import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_JOB_PURCHASE_ORDER,
  LINK_PURCHASE_ORDER_JOBS,
  UPDATE_PURCHASE_ORDER,
} from '../../../graph-queries/tar/purchaseOrder';
import { TPurchaseOrder } from '../../../lib/types';
import AspectsTable from '../AspectsTable/AspectsTable';
import PurchaseOrderForm from '../PurchaseOrderForm/PurchaseOrderForm';
import classes from './JobAspects.module.scss';
import { columns } from '../../pages/PurchaseOrders/PurchaseOrders';
import { useParams } from 'react-router-dom';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobPurchaseOrder: React.FC = () => {
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');
  const { data, loading } = useQuery(GET_JOB_PURCHASE_ORDER, {
    variables: { jobId },
  });
  const [updatePurchaseOrder] = useMutation(UPDATE_PURCHASE_ORDER, {
    refetchQueries: [GET_JOB_PURCHASE_ORDER],
  });
  const [linkPurchaseOrderJobs] = useMutation(LINK_PURCHASE_ORDER_JOBS, {
    refetchQueries: [GET_JOB_PURCHASE_ORDER],
  });

  const onEditSubmit = (purchaseOrder: TPurchaseOrder) => {
    const { updatedBy, updatedAt, tarJobs, ...input } = purchaseOrder;
    return updatePurchaseOrder({ variables: { input } });
  };

  const onLinkSubmit = (selection: TPurchaseOrder[], jobIds: number[]) => {
    return Promise.all(
      selection.map((purchaseOrder) =>
        linkPurchaseOrderJobs({
          variables: {
            purchaseOrderId: purchaseOrder.purchaseOrderId,
            jobIds: jobIds,
          },
        })
      )
    );
  };

  return (
    <AspectsTable<TPurchaseOrder>
      aspectName="purchase order"
      data={(data?.purchaseOrdersByJobId as unknown as TPurchaseOrder[]) || []}
      onLinkSubmit={onLinkSubmit}
      columns={columns}
      renderEditForm={(onClose, defaultValue) => (
        <PurchaseOrderForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>Purchase Orders</div>}
    />
  );
};

export default JobPurchaseOrder;
